import {IChangeLanguage, IFooterL10n} from "../interface/IFooter";


export const footerL10n: IFooterL10n = {
    ko: {
        linkList : {
            "companyLink": "회사소개",
            "termsOfService": "이용약관",
            "privacyPolicy": "개인정보처리방침",
            "guaranteeOfRights": "정보주체의 권리보장",
            "customerSupport": "고객지원",
            "cookiePolicy": "쿠키정책",
            "declarationOfSafety": "안심・안전 선언",
            "youthProtectionPolicy": "청소년보호정책",
            "communityPolicy": "커뮤니티정책",
            "operationPolicy": "운영정책",
            "doNotSell": "Do Not Sell My Personal Information",
            "gameGrade": "게임이용등급",
            "communityPolicyView": "커뮤니티정책",
            "servicePolicy": "서비스정책",
            "termsOfUse": "회원정책",
            "operationPolicyNCJ": "운영방침",
        },
        footerWords:{
            "gameRelatedLaw": "게임 관련 볍령에 따른 추가 표기",
            "brandInformation": "상호정보",
            "copyright": "카피라이트",
            "channelingInfo": "(주)엔씨소프트는 plaync 내 채널링 게임의 제공을 중개하는 통신판매중개자이며 통신판매의 당사자가 아닙니다.<br>채널링 게임의 제공과 관련된 모든 의무와 책임은 개별 통신판매업자에게 있으며, 이와 관련하여 발생하는 문제에 대해 당사는 책임을 부담하지 않습니다."
        },
        infoCS: {
            "businessInformation": "사업자정보확인",
            "infoAddress": "상호 (주)엔씨소프트 대표 김택진 사업자 등록번호 144-85-04244 통신판매업신고 제2013-경기성남-1268호",
            "mobile": "주소 경기도 성남시 분당구 대왕판교로 644번길 12 고객상담 1566-7004 팩스 02-2186-3499",
            "pc": "주소 경기도 성남시 분당구 대왕판교로 644번길 12 고객상담 1600-0020 팩스 02-2186-3550",
            "other": "주소 경기도 성남시 분당구 대왕판교로 644번길 12 고객상담 1600-0020(PC게임), 1566-7004(모바일게임) 팩스 02-2186-3550(PC게임), 02-2186-3499(모바일게임)",
            "none": '',
            "infoEmail": "이메일"
        },
        infoJP:{
            "jpTitle": "타이틀",
            "jpGenre": "장르",
            "jpPrice": "가격",
            "jpPriceValue": "무료 (인 앱 결제 상품 포함)",
            "jpOs": "대응OS",
            "jpDevelopedBy": "개발처/운영처",
            "jpReleaseDay": "릴리즈일",
            "jpReleaseDayValue_LW": "2021년 11월 4일",
        },
        "country": {
            "KR": "대한민국",
            "TW": "대만",
            "RU": "러시아",
            "MY": "말레이시아",
            "SA": "사우디아라비아",
            "SG": "싱가포르",
            "AE": "아랍에미리트",
            "ID": "인도네시아",
            "JP": "일본",
            "QA": "카타르",
            "TH": "태국",
            "PH": "필리핀",
            "HK": "홍콩",
            "UA": "우크라이나",
            "BY": "벨라루스",
            "LT": "리투아니아",
            "PL": "폴란드",
            "GR": "그리스",
            "IL": "이스라엘",
            "KW": "쿠웨이트",
            "AT": "오스트리아",
            "US": "미국",
            "CA": "캐나다",
            "DE": "독일",
            "GB": "영국",
            "FR": "프랑스",
            "BR": "브라질",
            "IT": "이탈리아",
            "ES": "스페인",
            "CL": "칠레",
            "NO": "노르웨이",
            "SE": "스웨덴",
            "IE": "아일랜드",
            "PT": "포르투갈",
            "FI": "핀란드",
            "DK": "덴마크",
            "CH": "스위스",
            "AR": "아르헨티나",
            "PE": "페루",
            "MX": "멕시코",
            "KZ": "카자흐스탄",
            "UZ": "우즈베키스탄",
            "AZ": "아제르바이잔",
            "GE": "조지아",
            "MD": "몰도바",
            "AM": "아르메니아",
            "NC": "Global"
        }
    },
    zh: {
        linkList : {
            "companyLink": "公司介紹",
            "termsOfService": "使用條款",
            "privacyPolicy": "個人資料保護政策",
            "guaranteeOfRights": "個人資料權益保障",
            "customerSupport": "顧客支援",
            "cookiePolicy": "Cookie政策",
            "declarationOfSafety": "安心・安全宣言",
            "youthProtectionPolicy": "青少年保護政策",
            "communityPolicy": "社群政策",
            "operationPolicy": "營運政策",
            "doNotSell": "Do Not Sell My Personal Information",
            "gameGrade": "게임이용등급",
            "communityPolicyView": "커뮤니티정책",
            "servicePolicy": "服務合約書",
            "termsOfUse": "會員規範",
            "operationPolicyNCJ": "운영방침",
        },
        footerWords:{
            "gameRelatedLaw": "根據遊戲相關法令之附加標記",
            "brandInformation": "企業資訊",
            "copyright": "版權",
            "channelingInfo": "（株）NCSOFT是通訊販售仲介平台，提供plaync內共享使用管道的遊戲之媒介服務，並非通訊販售當事業者。<br>與提供共享使用管道遊戲相關的全數義務和責任，均由各別通訊販售業者承擔，本公司對與此相關的任何問題概不負責。"
        },
        infoCS:{
            "businessInformation": "確認企業資訊",
            "infoAddress": "企業：（株）NCSOFT 代表：金澤辰 營業執照編號：144-85-04244 通訊販售業申報：第2013-京畿城南-1268號",
            "mobile": "住址 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea 客服電話 +82-1566-7004 傳真 +82-2-2186-3499",
            "pc": "",
            "other": "住址 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea 客服電話 +82-1600-0020（PC遊戲）， +82-1566-7004（手機遊戲）傳真 +82-2-2186-3550（PC遊戲）， +82-2-2186-3499（手機遊戲） ",
            "none": '',
            "infoEmail": "電子郵件",
        },
        infoJP:{
            "jpReleaseDayValue_LW": "2021年11月04日",
            "jpReleaseDay": "發行日",
            "jpDevelopedBy": "開發商／營運商",
            "jpOs": "對應OS",
            "jpPriceValue": "免費 (遊戲內另提供付費商品)",
            "jpPrice": "價格",
            "jpGenre": "類型",
            "jpTitle": "標題",
        },
        "country": {
            "HK": "香港",
            "PH": "菲律賓",
            "TH": "泰國",
            "QA": "卡達",
            "JP": "日本",
            "ID": "印尼",
            "AE": "阿拉伯聯合大公國",
            "SG": "新加坡",
            "SA": "沙烏地阿拉伯",
            "MY": "馬來西亞",
            "RU": "俄羅斯",
            "TW": "台灣",
            "KR": "韓國",
            "UA": "烏克蘭",
            "BY": "白俄羅斯",
            "LT": "立陶宛 ",
            "PL": "波蘭",
            "GR": "希臘",
            "IL": "以色列",
            "KW": "科威特",
            "AT": "奧地利",
            "US": "美國",
            "CA": "加拿大",
            "DE": "德國",
            "GB": "英國",
            "FR": "法國",
            "BR": "巴西",
            "IT": "義大利",
            "ES": "西班牙",
            "CL": "智利",
            "NO": "挪威",
            "SE": "瑞典",
            "IE": "愛爾蘭",
            "PT": "葡萄牙",
            "FI": "芬蘭",
            "DK": "丹麥",
            "CH": "瑞士",
            "AR": "阿根廷",
            "PE": "秘魯",
            "MX": "墨西哥",
            "KZ": "哈薩克斯坦",
            "UZ": "烏茲別克斯坦",
            "AZ": "阿塞拜疆",
            "GE": "喬治亞州",
            "MD": "摩爾多瓦",
            "AM": "亞美尼亞",
            "NC": "Global"
        }
    },
    ja: {
        linkList : {
            "companyLink": "会社紹介",
            "termsOfService": "利用規約",
            "privacyPolicy": "プライバシーポリシー",
            "guaranteeOfRights": "データ主体の権利",
            "operationPolicy": "運営ポリシー",
            "communityPolicy": "コミュニティポリシー",
            "youthProtectionPolicy": "青少年保護政策",
            "declarationOfSafety": "安心・安全宣言",
            "cookiePolicy": "クッキーポリシー",
            "customerSupport": "お問い合わせ",
            "doNotSell": "Do Not Sell My Personal Information",
            "gameGrade": "게임이용등급",
            "communityPolicyView": "コミュニティ運営ポリシー",
            "servicePolicy": "서비스정책",
            "termsOfUse": "회원정책",
            "operationPolicyNCJ": "運営方針",
        },
        footerWords:{
            "gameRelatedLaw": "ゲーム関連法律に基づく追加表記",
            "brandInformation": "商号情報",
            "copyright": "著作権情報",
            "channelingInfo": "㈱NCSOFTはplaync内チャネリングサービスの提供を仲介する通信販売仲介業者であり、通信販売の当事者ではありません。<br>チャンリングサービスの提供に関連したすべての義務と責任は個別の通信販売事業者にあり、これに関連して発生した問題に対して、当社は責任を負いません。"
        },
        infoCS:{
            "businessInformation": "事業者情報確認",
            "infoAddress": "事業者名 ㈱NCSOFT 代表 キム・テクジン 事業者登録番号 144-85-04244 通信販売業申告 第2013-京義城南-1268号",
            "mobile": "住所 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea お客様相談室 +82-1566-7004 FAX +82-2-2186-3499",
            "pc": "",
            "other": "住所 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea お客様相談室 +82-1600-0020(PCゲーム)、+82-1566-7004(モバイルゲーム)、FAX +82-2-2186-3550(PCゲーム)、+82-2-2186-3499(モバイルゲーム)",
            "none": '',
            "infoEmail": "Eメール",
        },
        infoJP:{
            "jpReleaseDayValue_LW": "2021年11月4日",
            "jpReleaseDay": "リリース日",
            "jpDevelopedBy": "開発/運営",
            "jpOs": "対応OS",
            "jpPriceValue": "基本無料 (アイテム課金あり)",
            "jpPrice": "価格",
            "jpGenre": "ジャンル",
            "jpTitle": "タイトル",
        },
        "country": {
            "HK": "香港",
            "PH": "フィリピン",
            "TH": "タイ",
            "QA": "カタール",
            "JP": "日本",
            "ID": "インドネシア",
            "AE": "アラブ首長国連邦",
            "SG": "シンガポール",
            "SA": "サウジアラビア",
            "MY": "マレーシア",
            "RU": "ロシア",
            "TW": "台湾",
            "KR": "大韓民国",
            "UA": "ウクライナ",
            "BY": "ベラルーシ",
            "LT": "リトアニア",
            "PL": "ポーランド",
            "GR": "ギリシャ",
            "IL": "イスラエル",
            "KW": "クウェート",
            "AT": "オーストリア",
            "US": "アメリカ",
            "CA": "カナダ",
            "DE": "ドイツ",
            "GB": "英国",
            "FR": "フランス",
            "BR": "ブラジル",
            "IT": "イタリア",
            "ES": "スペイン",
            "CL": "チリ",
            "NO": "ノルウェー",
            "SE": "スウェーデン",
            "IE": "アイルランド",
            "PT": "ポルトガル",
            "FI": "フィンランド",
            "DK": "デンマーク",
            "CH": "スイス",
            "AR": "アルゼンチン",
            "PE": "ペルー",
            "MX": "メキシコ",
            "KZ": "カザフスタン",
            "UZ": "ウズベキスタン",
            "AZ": "アゼルバイジャン",
            "GE": "ジョージア",
            "MD": "モルドバ",
            "AM": "アルメニア",
            "NC": "Global"
        }
    },
    en: {
        linkList : {
            "operationPolicy": "Operation Policy",
            "communityPolicy": "Community Policy",
            "youthProtectionPolicy": "Youth Protection Policy",
            "declarationOfSafety": "Security・Safety Declaration",
            "cookiePolicy": "Cookie Policy",
            "customerSupport": "SUPPORT",
            "guaranteeOfRights": "Rights of the Data Subject",
            "privacyPolicy": "Privacy Policy",
            "termsOfService": "Terms of Use",
            "companyLink": "About Us",
            "doNotSell": "Do Not Sell My Personal Information",
            "gameGrade": "게임이용등급",
            "communityPolicyView": "커뮤니티정책",
            "servicePolicy": "서비스정책",
            "termsOfUse": "회원정책",
            "operationPolicyNCJ": "운영방침",
        },
        footerWords:{
            "gameRelatedLaw": "Additional Information Following Gaming Laws",
            "brandInformation": "Company Name Information",
            "copyright": "Copyright",
            "channelingInfo": "NCSOFT is a broker who mediates mail order sales of channeling games within plaync, and is not a sales party of the aforementioned sales.<br>All obligations and responsibilities associated with the provided channeling games lay with the individual mail order sales party, and we are not responsible for issues regarding them."
        },
        infoCS:{
            "businessInformation": "View Business Information",
            "infoAddress": "Company Name: NCSOFT Corporation, CEO: Kim Taek-Jin, Business Registration Number: 144-85-04244, E-commerce Registration: 2013-Gyeonggi Seongnam-1268",
            "mobile": "Address: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea. Customer SUPPORT: +82 1566-7004. Fax: +82 02-2186-3499.",
            "pc": "",
            "other": "Address: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea. Customer SUPPORT: +82 1600-0020 (PC Game), +82 1566-7004 (Mobile Game). Fax: +82 02-2186-3550 (PC Game), +82 02-2186-3499 (Mobile Game).",
            "none": '',
            "infoEmail": "E-mail",
        },
        infoJP:{
            "jpReleaseDayValue_LW": "04 Novemver 2021",
            "jpReleaseDay": "Release Date",
            "jpDevelopedBy": "Developer/Publisher",
            "jpOs": "Supported OS",
            "jpPriceValue": "Free to Play (Contains in-app purchases)",
            "jpPrice": "Price",
            "jpGenre": "Genre",
            "jpTitle": "Title",
        },
        "country": {
            "HK": "Hong Kong",
            "PH": "Philippines",
            "TH": "Thailand",
            "QA": "Qatar",
            "JP": "Japan",
            "ID": "Indonesia",
            "AE": "United Arab Emirates",
            "SG": "Singapore",
            "SA": "Saudi Arabia",
            "MY": "Malaysia",
            "RU": "Russia",
            "TW": "Taiwan",
            "KR": "Republic of Korea",
            "UA": "Ukraine",
            "BY": "Belarus",
            "LT": "Lithuania",
            "PL": "Poland",
            "GR": "Greece",
            "IL": "Israel",
            "KW": "Kuwait",
            "AT": "Austria",
            "US": "United States of America",
            "CA": "Canada",
            "DE": "Germany",
            "GB": "United Kingdom",
            "FR": "France",
            "BR": "Brazil",
            "IT": "Italy",
            "ES": "Spain",
            "CL": "Chile",
            "NO": "Norway",
            "SE": "Sweden",
            "IE": "Ireland",
            "PT": "Portugal",
            "FI": "Finland",
            "DK": "Denmark",
            "CH": "Switzerland",
            "AR": "Argentina",
            "PE": "Peru",
            "MX": "Mexico",
            "KZ": "Kazakhstan",
            "UZ": "Uzbekistan",
            "AZ": "Azerbaijan",
            "GE": "Georgia",
            "MD": "Moldova",
            "AM": "Armenia",
            "NC": "Global"
        }
    },
    th: {
        linkList : {
            "operationPolicy": "นโยบายการดำเนินงาน",
            "communityPolicy": "นโยบายชุมชน",
            "youthProtectionPolicy": "นโยบายการคุ้มครองเยาวชน",
            "declarationOfSafety": "ประกาศทางการเกี่ยวกับความปลอดภัยและความไว้วางใจ",
            "cookiePolicy": "นโยบายคุกกี้",
            "customerSupport": "ศูนย์ช่วยเหลือลูกค้า",
            "guaranteeOfRights": "การรับรองสิทธิ์ของข้อมูลส่วนสำคัญ",
            "privacyPolicy": "นโยบายการจัดการข้อมูลส่วนตัว",
            "termsOfService": "ข้อตกลงในการใช้บริการ",
            "companyLink": "แนะนำบริษัท",
            "doNotSell": "Do Not Sell My Personal Information",
            "gameGrade": "게임이용등급",
            "communityPolicyView": "커뮤니티정책",
            "servicePolicy": "서비스정책",
            "termsOfUse": "회원정책",
            "operationPolicyNCJ": "운영방침",
        },
        footerWords:{
            "gameRelatedLaw": "สัญลักษณ์เพิ่มเติมตามกฎหมายที่เกี่ยวข้องกับเกม",
            "brandInformation": "ข้อมูลบริษัท",
            "copyright": "copyright",
            "channelingInfo": "บริษัท NCSOFT จำกัด (มหาชน) เป็นบริษัทกลางการผลิตและจัดจำหน่ายเกมภายใน plaync ไม่ใช่เป็นเจ้าตัวการผลิตและจัดจำหน่ายเกม<br>หน้าที่และความรับผิดชอบทั้งหมดที่เกี่ยวข้องกับการผลิตและจัดจำหน่าย จะอยู่ที่เจ้าตัวเกมแต่ละราย เราจะไม่รับผิดชอบต่อปัญหาใดๆ ที่เกิดขึ้นเกี่ยวกับเรื่องนี้"
        },
        infoCS:{
            "businessInformation": "ตรวจสอบข้อมูลนักธุรกิจ",
            "infoAddress": "MR. KIM TAEK-JIN ประธานบริหารบริษัท NCSOFT จำกัด (มหาชน) เลขทะเบียนนิติบุคคล: 144-85-04244 หมายเลขธุรกิจออนไลน์: เลขที่ 2013-Gyeonggi-Seongnam-1268",
            "infoEmail": "อีเมล",
            "mobile": "ที่อยู่: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea ศูนย์บริการลูกค้า: +82-1566-7004 โทรสาร: +82-2-2186-3499",
            "pc": "",
            "other": "ที่อยู่: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea ศูนย์บริการลูกค้า: +82-1600-0020 (เกม PC), +82-1566-7004 (เกมมือถือ) โทรสาร: +82-2-2186-3550 (เกม PC), +82-2-2186-3499 (เกมมือถือ)",
            "none": ''
        },
        infoJP:{
            "jpReleaseDayValue_LW": "4 พฤศจิกายน 2564",
            "jpReleaseDay": "วันที่เปิดให้บริการ",
            "jpDevelopedBy": "ฝ่ายพัฒนา/ฝ่ายบริหาร",
            "jpOs": "การตอบสนอง OS",
            "jpPriceValue": "เล่นฟรี (มีการซื้อในแอป)",
            "jpPrice": "ราคา",
            "jpGenre": "ประเภท",
            "jpTitle": "ชื่อเรื่อง",
        },
        "country": {
            "HK": "ฮ่องกง",
            "PH": "ฟิลิปปินส์",
            "TH": "ไทย",
            "QA": "กาตาร์",
            "JP": "ญี่ปุ่น",
            "ID": "อินโดนีเซีย",
            "AE": "สหรัฐอาหรับเอมิเรตส์",
            "SG": "สิงคโปร์",
            "SA": "ซาอุดิอาระเบีย",
            "MY": "มาเลเซีย",
            "RU": "รัสเซีย",
            "TW": "ไต้หวัน",
            "KR": "เกาหลีใต้",
            "UA": "ยูเครน",
            "BY": "เบลารุส",
            "LT": "ลิทัวเนีย",
            "PL": "โปแลนด์",
            "GR": "กรีซ",
            "IL": "อิสราเอล",
            "KW": "คูเวต",
            "AT": "ออสเตรีย",
            "US": "สหรัฐอเมริกา",
            "CA": "แคนาดา",
            "DE": "เยอรมนี",
            "GB": "อังกฤษ",
            "FR": "ฝรั่งเศษ",
            "BR": "บราซิล",
            "IT": "อิตาลี",
            "ES": "สเปน",
            "CL": "ชิลี",
            "NO": "นอร์เวย์",
            "SE": "สวีเดน",
            "IE": "ไอร์แลนด์",
            "PT": "โปรตุเกส",
            "FI": "ฟินแลนด์",
            "DK": "เดนมาร์ก",
            "CH": "สวิตเซอร์แลนด์",
            "AR": "อาร์เจนตินา",
            "PE": "เปรู",
            "MX": "แม็กซิโก",
            "KZ": "คาซัคสถาน",
            "UZ": "อุซเบกิสถาน",
            "AZ": "อาเซอร์ไบจาน",
            "GE": "จอร์เจีย",
            "MD": "มอลโดวา",
            "AM": "อาร์เมเนีย",
            "NC": "Global"
        }
    },
    ru: {
        linkList : {
            "operationPolicy": "Политика пользования",
            "communityPolicy": "Правила сообщества",
            "youthProtectionPolicy": "Политика защиты несовершеннолетних",
            "declarationOfSafety": "Декларация о безопасности",
            "cookiePolicy": "Политика использования Cookies",
            "customerSupport": "Служба поддержки",
            "guaranteeOfRights": "Гарантия прав субъектов данных",
            "privacyPolicy": "Политика конфиденциальности",
            "termsOfService": "Пользовательское соглашение",
            "companyLink": "Описание компании",
            "doNotSell": "Do Not Sell My Personal Information",
            "gameGrade": "게임이용등급",
            "communityPolicyView": "커뮤니티정책",
            "servicePolicy": "서비스정책",
            "termsOfUse": "회원정책",
            "operationPolicyNCJ": "운영방침",
        },
        footerWords:{
            "gameRelatedLaw": "Дополнительные примечания в связи с законом о регулировании игр",
            "brandInformation": "Информация о названии компании",
            "copyright": "Авторское право",
            "channelingInfo": "NCSOFT Corporation является посредником в предоставлении игр с восможностью использования единого игрового ID в plaync, но не является заинтересованным лицом в осуществлении их продаж.<br>Все обязательства и ответственность, связанные с предоставлением данных игр, возлагается на официальных представителей по прадаже. За все проблемы, возникающие в данных играх, NCSOFT Corporation ответственности не несёт."
        },
        infoCS:{
            "businessInformation": "Проверка данных предпринимателя",
            "infoAddress": "Президент компании NCSOFT Corporation - Kim Taek Jin Номер удостоверения предпринимателя: 144-85-04244 Заявление на ведение онлайн-продаж: 2013-Gyeonggi Seongnam-1268",
            "mobile": "Адрес: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea. Служба поддержки: +82-1566-7004. Факс: +82-2-2186-3499",
            "pc": "",
            "other": "Адрес: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea. Служба поддержки: +82-1600-0020 (игры для ПК), +82-1566-7004 (мобильные игры). Факс: +82-2-2186-3550 (игры для ПК), +82-2-2186-3499 (мобильные игры).",
            "none": '',
            "infoEmail": "Электронная почта",
        },
        infoJP:{
            "jpReleaseDayValue_LW": "4 ноября 2021",
            "jpReleaseDay": "Дата выпуска",
            "jpDevelopedBy": "Отдел разработок/Отдел управления",
            "jpOs": "Совместимая ОС",
            "jpPriceValue": "Бесплатно (Поддерживаются покупки в приложении)",
            "jpPrice": "Стоимость",
            "jpGenre": "Жанр",
            "jpTitle": "Название",
        },
        "country": {
            "HK": "Гонконг",
            "PH": "Филиппины",
            "TH": "Таиланд",
            "QA": "Катар",
            "JP": "Япония",
            "ID": "Индонезия",
            "AE": "Арабские Эмираты",
            "SG": "Сингапур",
            "SA": "Саудовская Аравия",
            "MY": "Малайзия",
            "RU": "Россия",
            "TW": "Тайвань",
            "KR": "Республика Корея",
            "UA": "Украина",
            "BY": "Белоруссия",
            "LT": "Литва",
            "PL": "Польша",
            "GR": "Греция",
            "IL": "Израиль",
            "KW": "Кувейт",
            "AT": "Австрия",
            "US": "США",
            "CA": "Канада",
            "DE": "Германия",
            "GB": "Великобритания",
            "FR": "Франция",
            "BR": "Бразилия",
            "IT": "Италия",
            "ES": "Испания",
            "CL": "Чили",
            "NO": "Норвегия",
            "SE": "Швеция",
            "IE": "Ирландия",
            "PT": "Португалия",
            "FI": "Финляндия",
            "DK": "Дания",
            "CH": "Швейцария",
            "AR": "Аргентина",
            "PE": "Перу",
            "MX": "Мексика",
            "KZ": "Казахстан",
            "UZ": "Узбекистан",
            "AZ": "Азербайджан",
            "GE": "Грузия",
            "MD": "Молдова",
            "AM": "Армения",
            "NC": "Global"
        }
    },
    id: {
        linkList : {
            "operationPolicy": "Kebijakan Operasional",
            "communityPolicy": "Kebijakan Komunitas",
            "youthProtectionPolicy": "Kebijakan Perlindungan Anak dan Remaja",
            "declarationOfSafety": "Deklarasi Keamanan",
            "cookiePolicy": "Kebijakan Cookie",
            "customerSupport": "Layanan Pelanggan",
            "guaranteeOfRights": "Hak Subjek Data",
            "privacyPolicy": "Kebijakan Privasi",
            "termsOfService": "Persyaratan Layanan",
            "companyLink": "Tentang Perusahaan",
            "doNotSell": "Do Not Sell My Personal Information",
            "gameGrade": "게임이용등급",
            "communityPolicyView": "커뮤니티정책",
            "servicePolicy": "서비스정책",
            "termsOfUse": "회원정책",
            "operationPolicyNCJ": "운영방침",
        },
        footerWords:{
            "gameRelatedLaw": "Informasi Tambahan Sesuai Undang-Undang Terkait Game",
            "brandInformation": "Informasi Nama Perusahaan",
            "copyright": "Hak Cipta",
            "channelingInfo": "NCSOFT Corporation hanya bertindak sebagai mediator dalam menyediakan channeling game dalam plaync. NCSOFT Corporation tidak menangani langsung penyediaan layanan game maupun transaksi elektronik pada game tersebut.<br>Kewajiban dan tanggung jawab yang berkaitan dengan layanan dari channeling game ada pada perusahaan masing-masing game. NCSOFT Corporation tidak bertanggung jawab atas masalah yang terjadi berkaitan dengan game tersebut."
        },
        infoCS:{
            "businessInformation": "Periksa Informasi Bisnis",
            "infoAddress": "NCSOFT Corporation CEO Kim Taek-jin Nomor Register Perusahaan 144-85-04244 Nomor Pendaftaran Perusahaan Perdagangan Elektronik 2013-Gyeonggi Seongnam-No. 1268",
            "infoEmail": "Email",
            "mobile": "Alamat: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republik Korea Layanan Pelanggan: +82-1566-7004 FAX: +82-2-2186-3499",
            "pc": "",
            "other": "Alamat: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republik Korea Layanan Pelanggan: +82-1600-0020 (Game PC), +82-1566-7004 (Game Mobile) FAX: +82-2-2186-3550 (Game PC), +82-2-2186-3499 (Game Mobile)",
            "none": '',
        },
        infoJP:{
            "jpReleaseDayValue_LW": "04 Novemver 2021",
            "jpReleaseDay": "Tanggal Rilis",
            "jpDevelopedBy": "Developer/Operator",
            "jpOs": "Sistem Operasi",
            "jpPriceValue": "Gratis (termasuk pembelian dalam aplikasi)",
            "jpPrice": "Harga",
            "jpGenre": "Genre",
            "jpTitle": "Judul",
        },
        "country": {
            "HK": "Hong Kong",
            "PH": "Filipina",
            "TH": "Thailand",
            "QA": "Qatar",
            "JP": "Jepang",
            "ID": "Indonesia",
            "AE": "Uni Emirat Arab",
            "SG": "Singapura",
            "SA": "Arab Saudi",
            "MY": "Malaysia",
            "RU": "Rusia",
            "TW": "Taiwan",
            "KR": "Republik Korea",
            "UA": "Ukraina",
            "BY": "Belarus",
            "LT": "Lituania",
            "PL": "Polandia",
            "GR": "Yunani",
            "IL": "Israel",
            "KW": "Kuwait",
            "AT": "Austria",
            "US": "Amerika Serikat",
            "CA": "Kanada",
            "DE": "Jerman",
            "GB": "Britania Raya",
            "FR": "Prancis",
            "BR": "Brasil",
            "IT": "Italia",
            "ES": "Spanyol",
            "CL": "Chili",
            "NO": "Norwegia",
            "SE": "Swedia",
            "IE": "Irlandia",
            "PT": "Portugal",
            "FI": "Finlandia",
            "DK": "Denmark",
            "CH": "Swiss",
            "AR": "Argentina",
            "PE": "Peru",
            "MX": "Meksiko",
            "KZ": "Kazakstan",
            "UZ": "Uzbekistan",
            "AZ": "Azerbaijan",
            "GE": "Georgia",
            "MD": "Moldova",
            "AM": "Armenia",
            "NC": "Global"
        }
    },
    ar: {
        linkList : {
            "operationPolicy": "سياسة الاستخدام",
            "communityPolicy": "السياسة المجتمعية",
            "youthProtectionPolicy": "سياية حماية القاصرين",
            "declarationOfSafety": "إعلان ألأمن والتأمين",
            "cookiePolicy": "سياسة سجل التتبع",
            "customerSupport": "خدمة العملاء",
            "guaranteeOfRights": "كفالة الحقوق",
            "privacyPolicy": "الخصوصية",
            "termsOfService": "شروط الخدمة",
            "companyLink": "مقدمة الشركة",
            "doNotSell": "Do Not Sell My Personal Information",
            "gameGrade": "게임이용등급",
            "communityPolicyView": "커뮤니티정책",
            "servicePolicy": "서비스정책",
            "termsOfUse": "회원정책",
            "operationPolicyNCJ": "운영방침",
        },
        footerWords:{
            "gameRelatedLaw": "علامة إضافية وفقًا للقوانين المتعلقة باللعبة",
            "brandInformation": "معلومات العلامة التجارية",
            "copyright": "حقوق التأليف والنشر",
            "channelingInfo": "NCSOFT Co.، Ltd. هي شركة وسيطة لشركات التعامل التجاري بالمراسلة. هي تتوسط في توفير ألعاب داخل plaync وليست معنية بالتعامل التجاري بالمراسلة مباشرة.<br>جميع الالتزامات والمسؤوليات المتعلقة بتوفير الألعاب خاصة بشركات التعامل التجاري بالمراسلة، ونحن لا نتحمل مسؤولية أي مشاكل تنشأ فيما يتعلق بذلك."
        },
        infoCS:{
            "businessInformation": "التحقق من المعلومات التجارية",
            "infoAddress": "اسم الشركة NCsoft Co.، Ltd. الرئيس التنفيذي كيم تايك جين رقم تسجيل الأعمال 144-85-04244 تقرير أعمال الطلب عبر البريد 2013-Gyeonggi Seongnam-1268",
            "mobile": "العنوان:  12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea الدعم:+82-1566-7004  الفاكس:+82-2-2186-3499",
            "pc": "",
            "other": "العنوان:  12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea الدعم:+82-1600-0020(ألعاب الكمبيوتر), +82-1566-7004(ألعاب الجوال)  الفاكس:+82-2-2186-3550(ألعاب الكمبيوتر), +82-2-2186-3499(ألعاب الجوال)",
            "none": '',
            "infoEmail": "البريد الإلكتروني",
        },
        infoJP:{
            "jpReleaseDayValue_LW": "4نوفمبر 2021",
            "jpReleaseDay": "يوم الاصدار",
            "jpDevelopedBy": "مطور/مشغل من طرف",
            "jpOs": "نظام تشغيل المراسلات",
            "jpPriceValue": "(مجاني (يحتوي على مشتريات داخل التطبيق",
            "jpPrice": "السعر",
            "jpGenre": "نوع",
            "jpTitle": "عنوان",
        },
        "country": {
            "HK": "هونغ كونغ",
            "PH": "الفيليبين",
            "TH": "تايلاند",
            "QA": "قطر",
            "JP": "اليابان",
            "ID": "أندونيسيا",
            "AE": "الإمارات العربية المتحدة",
            "SG": "سنغافورة",
            "SA": "المملكة العربية السعودية",
            "MY": "ماليزيا",
            "RU": "روسيا",
            "TW": "تايوان",
            "KR": "جمهورية كوريا الجنوبية",
            "UA": "أوكرانيا",
            "BY": "بيلاروس",
            "LT": "ليتوانيا",
            "PL": "بولندا",
            "GR": "اليونان",
            "IL": "إسرائيل",
            "KW": "الكويت",
            "AT": "النمسا",
            "US": "الولايات المتحدة الأمريكية",
            "CA": "كندا",
            "DE": "ألمانيا",
            "GB": "بريطانيا",
            "FR": "فرنسا",
            "BR": "البرازيل",
            "IT": "إيطاليا",
            "ES": "إسبانيا",
            "CL": "تشيلي",
            "NO": "النرويج",
            "SE": "السويد",
            "IE": "أيرلندا",
            "PT": "البرتغال",
            "FI": "فنلندا",
            "DK": "الدنمارك",
            "CH": "سويسرا",
            "AR": "الأرجنتين",
            "PE": "بيرو",
            "MX": "المكسيك",
            "KZ": "كازاخستان",
            "UZ": "أوزبكستان",
            "AZ": "أذربيجان",
            "GE": "جورجيا",
            "MD": "مولدوفا",
            "AM": "أرمينيا",
            "NC": "Global"
        }
    },
};

export const footerL10nLang: IChangeLanguage = {
    ko: "한국어",
    en: "English",
    zh: "中文－繁體",
    ja: "日本語",
    ar: "العربية",
    th: "ภาษาไทย",
    id: "Bahasa Indonesia",
    ru: "Русский"
};
